/* eslint-disable max-len */
export default {
    commonStrings: {
        Title: 'Common Strings ',
        Area: 'Area',
        Areas: 'Areas',
        Cancel: 'Cancel',
        Done: 'Done',
        downtimeText: 'Shopping witll be going down for maintenance in {0} minutes.',
        Error: 'Error',
        Minute: 'Minute',
        Minutes: 'Minutes',
        No: 'No',
        Off: 'Off',
        Ok: 'OK'
    },
    sharedStrings: {
        person: {
            name: 'Name',
            otherGender: 'Not listed / Prefer not to answer',
            gender: 'Gender',
            male: 'Male',
            female: 'Female',
            date_of_birth: 'Date of Birth',
            nationality: 'Nationality'
        },
        generic: {
            no: 'No',
            yes: 'Yes',
            back: 'Back',
            cancel: 'Cancel',
            continue: 'Continue',
            default: 'Default',
            other: 'Other',
            save: 'Save',
            ok: 'OK',
            print: 'Print',
            quantity: 'Quantity',
            optional: 'Optional',
            done: 'Done',
            enter: 'Enter',
            Select: 'Select',
            export_csv: 'Export to CSV',
            delete_agreement: 'Are you sure you want to delete this item?',
            processing: 'Processing...',
            size: 'Size'
        },
        accounts: {
            email_address: 'Email Address',
            username: 'Username',
            password: 'Password',
            sapId: 'Sap ID',
            create_password: 'Create Password',
            brand_affiliate_id: 'Brand Affiliate ID',
            customer: 'Customer',
            sponsor: 'Sponsor',
            sign_in: 'Sign In',
            phoneNumber: 'Phone Number'
        },
        address: {
            edit_address: 'Edit Address',
            line1: 'Address Line 1',
            line2: 'Address Line 2',
            city: 'City',
            state: 'State',
            zip: 'Zip Code'
        },
        forms: {
            back: 'Back',
            show: 'Show',
            hide: 'Hide',
            invalid: 'Invalid',
            required: 'required',
            browse: 'Browse',
            invalidPhoneNumber: 'Invalid Phone Number Format',
            fieldBadEmail: 'Field must be an email address'
        },
        profile: {
            edit_address: 'Edit Address'
        },
        email_verification: {
            email_verify_card_verify_header: 'VERIFY YOUR EMAIL / USERNAME',
            email_username_update_content: 'In order to improve our site security, your username must be a unique email address. Your username is currently not an email, please update to an email.',
            email_verify_card_verify_content: 'In order to improve our site security, an email address can only be used for one account. Please confirm this email is yours only or edit it.',
            email_verify_card_verify_current_username: 'Current Email / Username',
            email_verify_card_success_header: 'Your email has been verified',
            email_verify_card_verify_button: 'VERIFY YOUR EMAIL / USERNAME',
            email_verify_card_verify_change_button: 'EDIT YOUR EMAIL / USERNAME',
            email_verify_card_info_header: 'You\'ve got mail',
            email_verify_card_success_content: 'Use it to log in next time',
            email_verify_card_info_sent: 'Please check your email to verify your address.',
            email_verify_card_info_modified: 'Your email address has been modified and will now be used as your username. Please check your emails to verify your address',
            email_verify_card_info_resend: 'Resend email verification',
            email_verify_card_info_resend_success: 'A verification email has been sent. This could take a few minutes.',
            email_verify_card_error_header: 'You have an error',
            email_verify_card_error_content: 'Network error',
            edit_email_modal_header: 'Edit your Email / Username',
            email_verify_card_current_email: 'Current Email',
            email_verify_card_current_username: 'Current Username',
            edit_email_modal_new_email_label: 'New Username',
            email_input_username_warning: 'Must be an email address',
            new_email_confirmation_sent: 'A confirmation link will be sent to this new email.',
            email_verification_email_linked_account: 'Your new email address will be linked to this Nu Skin account and will be used as your username.',
            personal_info_email_verified: 'Email Verified',
            personal_info_email_not_verified: 'Email Not Verified'
        },
        shipping_address: {
            choose_address_message: 'Choose Address Message',
            default_address: 'Default Address',
            save_address: 'Save Address',
            saved_address: 'Saved Addresses',
            shipping_address: 'Shipping Address',
            mobile_phone_label: 'Mobile Phone Label',
            instructions_label: 'Instructions Label',
            agree_to_save_address: 'Agree to Save Address',
            set_as_default: 'Set as Default',
            delete_address: 'Delete Address',
            server_error_title: 'Server Error Title',
            address_name: 'Address Name',
            invalid_phone: 'Invalid Phone' 
        }
    },
    personal: {
        title: 'Account Information',
        page_title: 'Account Information',
        card_title_account: 'Your Account',
        change_password: 'Change Password',
        profile_image_text: 'Profile Image',
        edit_profile_image: 'Edit Profile Image',
        browse: 'Browse',
        image_type: 'JPG, PNG, GIF are allowed',
        image_size: 'Max File Size - 15 MB',
        file_drop: 'Drop File Here',
        card_title_personal_information: 'Personal Information',
        edit_email_username: 'Edit Email',
        preferred_name: 'Preferred Name',
        edit_preferred_name: 'Edit Preferred Name',
        preferred_name_description: 'Please tell us the name you would like us to use when addressing you on our website.',
        current_preferred_name: 'Current Preferred Name',
        new_preferred_name: 'New Preferred Name',
        no_preferred_name: 'No Preferred Name',
        address_account_card_title: 'Account Address',
        address_account_card_description: 'This is your permanent address that we use for processing commission payments and tax reporting.',
        edit_gender: 'Edit Gender',
        aadd_date_of_birth: 'Add Date of Birth',
        acct_conv_acct_type: 'Account Type',
        acct_conv_tag_line: 'Are you getting the most out of your NuSkin account? Maximize your benefits by reviewing your account type now!',
        convert_account_tagline: 'As a customer, you can purchase products for a brand affiliate or directly from Nu Skin.',
        convert_account_button_text: 'UPGRADE TO BRAND AFFILLIATE',
        acct_conv_manage: 'Manage Account Type',
        acct_conv_type_dist: 'Brand Affiliate',
        acct_conv_type_pfc: 'Member',
        acct_conv_type_customer: 'Customer',
        hu_tax_info: {
            hu_edit_tax_info: 'Edit Tax Info',
            hu_tax_login: 'HU Tax Login',
            hu_tax_password: 'HU Tax Password',
            hu_tax_xml_signature: 'HU Tax XML Signature Key',
            hu_tax_xml_exchange: 'HU Tax XML Exchange Key',
            card_title_hu_tax: 'Tax Infomation',
            hu_tax_description: '',
            hu_tax_not_entered: 'Please Enter Your Tax Information'
        },
        error: {
            error: 'Error',
            error_occurred: 'An error has occurred'
        }
    },
    privacy: {
        title: 'Privacy Policy',
        page_title: 'Privacy Preferences',
        edit_privacy_preferences: 'Edit Privacy Preferences',
        upline_description: 'Share my contact information with my sponsoring Brand Affiliate and upline?',
        sponsor_search: 'Allow prospective customers to find me in sponsor search?',
        retail_privacy_label: 'Opt in to be contacted by a Nu Skin Brand Representative',
        retail_privacy_description: 'Nu Skin will select, and link your account to a Nu Skin Brand Representative (also known as a “sponsor”). As a result, that sponsor will have access to your personal information through our systems, including your contact details and purchase history. The sponsor may reach out to you for product support and/or to provide more information regarding our product range and company. You can withdraw your consent at any time. Please read our Privacy Notice for more information.',
        sponsor_label: 'Sponsor',
        group_label: 'Group Leaders',
        upline_rep_label: 'Upline Brand Representatives',
        communication_privacy_header: 'Communication Privacy',
        order_privacy_header: 'Order Privacy',
        order_privacy_desc: 'By checking the box below you are granting your upline with access to your order and subscription details.',
        order_privacy_edit_desc: 'By checking the box below you are granting your upline with access to your order and subscription details.',
        order_privacy_legal: 'Your order includes information about your purchases (product name, quantity, volume, price, order tracking, ship to details), as well as Subscription contract details (product name, quantity, price, ship to details). This information is made available by default to your sponsor until you qualify as a Brand Representative. This allows her/him to provide you with product support and training, as well as product recommendations. You can manage who has access to your order information by (un)checking the boxes. You can grant access to additional uplines to enable them to reach out to you for additional support and training.',
        name_only_label: 'Share My Name Only',
        full_info_label: 'Share all Personal Info',
        dont_share_info: 'Don\'t share my information'
    },
    address: {},
    categories: {
        title: 'Categories',
        personal_info: 'Account Information',
        communication_prefs: 'Communication Preferences',
        privacy: 'Privacy',
        address: 'Shipping Address',
        payment_methods: 'Payment Methods',
        order_history: 'Order History',
        direct_deposit: 'Direct Deposit',
        favorites: 'Favorites'
    },
    communication: {
        title: 'Communication Preferences',
        acct_header: 'Account Correspondence',
        email_header: 'Marketing Email',
        edit_email: 'Edit Marketing Email',
        email_desc: 'This will be your account’s primary email for account correspondence.',
        current_email: 'Current Marketing Email',
        new_email: 'New Marketing Email',
        mobile_number_header: 'Mobile Phone Number',
        edit_mobile_number: 'Edit Mobile Number',
        mobile_desc: 'Your mobile must be an Telephone number.',
        current_mobile: 'Current Mobile Number',
        new_mobile_number: 'New Mobile Number',
        promo_header: 'Promotional Correspondence',
        email_opt_in: 'Opt in to Emails',
        sms_opt_in: 'Opt in to SMS',
        edit_comm_preferences: 'Edit Communication Preferences',
        email_and_sms_desc: 'Opt in to receive messages for promotions, events, news, and more.',
        sms_messages_sent_to: 'Messages will be sent to your mobile:',
        preferred_language: 'Preferred Language',
        edit_pref_language: 'Edit Preferred Language',
        pref_language_desc: 'Preferred language is the language used for marketing emails and SMS messaging.',
        current_pref_language: 'Current Language',
        new_pref_language: 'New Language'
    },
    orderHistory: {
        title: 'Order History',
        date_range: 'Date Range',
        one_month: '1 Month',
        three_months: '3 Months',
        six_months: '6 Months',
        twelve_months: '12 Months',
        order_status: 'Order Status',
        all: 'All',
        backorder: 'Backorder',
        cancelled: 'Cancelled',
        complete: 'Complete',
        declined: 'Declined',
        incomplete: 'Incomplete',
        partial_return: 'Partial Return',
        payment_pending: 'Payment Pending',
        pending: 'Pending',
        pending_return: 'Pending Return',
        processing: 'Processing',
        returned: 'Returned',
        order_number: 'Order #',
        date: 'Date',
        total: 'Total',
        psv: 'SV',
        tracking_number: 'Tracking #',
        view_details: 'View Details',
        v_and_g_desc: 'These orders represent volume at time of purchase and are strictly for Order Status/Tracking.  For commissions based Order History please see VOLUMES & GENEALOGY.',
        no_orders_found: 'No Orders Found.',
        order_detail_title: 'Order Detail',
        return_order_url_title: 'Return Order',
        return_order_url: 'https://returns.narvar.com/nuskin/returns?locale=en_US',
        shipped_to: 'Shipped to',
        product: 'Product',
        price: 'Price',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        tax: 'Tax',
        vat: 'VAT',
        payment_information: 'Payment Information',
        shipping_method: 'Shipping Method'  
    },
    directDeposit: {
        title: 'Direct Deposit',
        page_title: 'Direct Deposit',
        direct_deposit_missing: 'Link your bank account to get payments from Nu Skin deposited directly into it.',
        add_bank_account: 'Add Bank Account',
        direct_deposit_explanation: 'Please enter your bank account information below. You may want to use a check to reference some of the information.',
        direct_deposit_name_acct: 'Name on Account',
        ca_bank_name: 'Bank Name',
        ca_branch_transit: 'Branch / Transit Number',
        account_type: 'Account Type',
        checking: 'Checking',
        savings: 'Savings',
        account_number: 'Account Number',
        routing_number: 'Routing Number',
        hint_text: 'Where can I find this?',
        hint_content: 'You can find this number on a check as shown below or on your bank’s website.',
        iban_number_label: 'IBAN',
        iban_mask_format: '######',
        cannot_add_bank_account_message: 'Bank information is only available in your home market.'
    },
    favorites: {
        title: 'Favorites',
        page_title: 'Favorites',
        no_favorites_text: 'You do not have any Favorite Products added for this market. To add a favorite, go to your favorite products and click the ADD TO LIST button.',
        added_to_favorites: 'Item added to favorites',
        removed_from_favorites: 'Item removed from favorites'
    },
    payment: {
        title: 'Payment Methods',
        other_payments: 'Other Payment Methods',
        add_payment_: 'Add Payment Method'
    },
    terms: {
        smsTerms: {
            title: 'SMS Agree to Terms',
            terms_text: 'Consent is not a condition of purchase. I have read, understand and agree to the SMS Terms Of Service. Message frequency will vary. Message and data rates may apply.'
        },
        directDeposit: {
            title: 'Direct Deposit',
            page_title: 'Direct Deposit',
            direct_deposit_missing: 'Link your bank account to get payments from Nu Skin deposited directly into it.',
            add_bank_account: 'Add Bank Account',
            direct_deposit_explanation: 'Please enter your bank account information below. You may want to use a check to reference some of the information.',
            direct_deposit_name_acct: 'Name on Account',
            ca_bank_name: 'Bank Name',
            ca_branch_transit: 'Branch / Transit Number',
            account_type: 'Account Type',
            checking: 'Checking',
            savings: 'Savings',
            account_number: 'Account Number',
            routing_number: 'Routing Number',
            hint_text: 'Where can I find this?',
            hint_content: 'You can find this number on a check as shown below or on your bank’s website.',
            iban_number_label: '',
            iban_mask_format: '',
            cannot_add_bank_account_message: 'Bank information is only available in your home market.',
            ddExplantion: {
                title: 'Direct Deposit Terms Explanation',
                terms_text: 'Commission payments will now be deposited into the above account. If you need to make changes, please call Distributor Support at 1-800-487-1000, option 4. Terms And Conditions'
            },
            ddTerms: {
                title: 'DD Agree to Terms',
                terms_text: 'I have read, understand and agree to the Terms and Conditions. Message frequency will vary. Message and data rates may apply.'
            }
        }
    }
}